import { IStore } from 'redux/root';
import { ILOV } from 'stubs/graphql/lov';

import { ILOVStore } from './reducer';

export const getAllLOVs = (store: IStore): ILOVStore => store.lov;

export const getItemCategory = (store: IStore): ILOV[] =>
  store.lov.itemCategory;

export const getItemSubCategory = (store: IStore): ILOV[] =>
  store.lov.itemSubCategory;

export const getItemQuality = (store: IStore): ILOV[] => store.lov.itemQuality;

export const getItemStyle = (store: IStore): ILOV[] => store.lov.itemStyle;

export const getItemBrandCategory = (store: IStore): ILOV[] =>
  store.lov.itemBrandCategory;

export const getItemSize = (store: IStore): ILOV[] => store.lov.itemSize;

export const getItemMaterial = (store: IStore): ILOV[] =>
  store.lov.itemMaterial;

export const getMembershipType = (store: IStore): ILOV[] =>
  store.lov.membershipType;

export const getMemberSource = (store: IStore): ILOV[] =>
  store.lov.memberSource;

export const getDeliveryType = (store: IStore): ILOV[] =>
  store.lov.deliveryType;

export const getDeliveryTypeCollectStatus = (store: IStore): ILOV[] =>
  store.lov.deliveryTypeCollectStatus;
